module.exports = __webpack_public_path__ + "img/thingstotry_xl.60127b34.png";